import { render, staticRenderFns } from "./returned.vue?vue&type=template&id=5be28f21&scoped=true"
import script from "./returned.vue?vue&type=script&lang=js"
export * from "./returned.vue?vue&type=script&lang=js"
import style0 from "./returned.vue?vue&type=style&index=0&id=5be28f21&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be28f21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be28f21')) {
      api.createRecord('5be28f21', component.options)
    } else {
      api.reload('5be28f21', component.options)
    }
    module.hot.accept("./returned.vue?vue&type=template&id=5be28f21&scoped=true", function () {
      api.rerender('5be28f21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/returned/returned.vue"
export default component.exports